import React, {useEffect, useState} from 'react';
import SearchPage from './components/SearchPage';
import './App.css';
import {fetchJwtToken, JwtResponse} from './TokenService';

const App: React.FC = () => {
    const [ loading, setLoading] = useState<boolean>(true)

    useEffect(() => {
        const getJwt = async() => {
            try {
                await fetchJwtToken();
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        getJwt();
    }, []);
    if (loading) {
        return <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>;
    }
    // once loading is done, localStorage already has the token and map key
    return (
        <div className="App">
            <SearchPage />
        </div>
    );
};

export default App;
